import { format, getDaysInMonth, isValid, parse } from 'date-fns';

export const DATE_INPUT_FORMAT = 'MM/dd/yyyy';
export const DATE_INPUT_PLACEHOLDER = 'MM/DD/YYYY';

function takeClampedField(digits: string, maxLead: number, maxValue: number): { field: string; rest: string } {
  if (digits.length === 0) return { field: '', rest: '' };
  const lead = Number(digits[0]);
  if (lead > maxLead) return { field: `0${lead}`, rest: digits.slice(1) };
  if (digits.length === 1) return { field: digits, rest: '' };
  const pair = Number(digits.slice(0, 2));
  const clamped = pair > maxValue ? String(maxValue) : digits.slice(0, 2);
  return { field: clamped, rest: digits.slice(2) };
}

export function formatDateInput(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  const month = takeClampedField(digits, 1, 12);
  const monthNumber = month.field.length === 2 ? Number(month.field) : 0;
  const maxDay = monthNumber >= 1 && monthNumber <= 12 ? getDaysInMonth(new Date(2000, monthNumber - 1, 1)) : 31;
  const day = takeClampedField(month.rest, 3, maxDay);
  const year = day.rest.slice(0, 4);

  const segments = [month.field];
  if (day.field !== '' || year !== '') segments.push(day.field);
  if (year !== '') segments.push(year);
  return segments.join('/');
}

export function parseTypedDate(value: string): Date | undefined {
  if (value.length < DATE_INPUT_PLACEHOLDER.length) return undefined;
  const parsed = parse(value, DATE_INPUT_FORMAT, new Date());
  if (!isValid(parsed) || format(parsed, DATE_INPUT_FORMAT) !== value) return undefined;
  return parsed;
}
